import dashboards from './dashboards'
import settings from './settings'
import reports from './reports'
import dailyLog from './dailyLog'
import billing from './billing'

// ** Helper Function to Detect Mobile View
const isMobileView = () => window.innerWidth <= 768 // Adjust breakpoint as needed

// ** Merge & Export Based on Viewport
const allModules = [...dashboards, ...dailyLog, ...reports, ...billing, ...settings]
const mobileModules = [...dashboards, ...dailyLog, ...reports, ...settings]

export default isMobileView() ? mobileModules : allModules
